// Customers getters
export default {
  get_invoice_list: (state) => state.items,
  get_invoice_count: (state) => state.count,
  get_invoice: (state) => state.invoice,
};
